import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./styles/global.css";
import { registerServiceWorker } from "./pwa/serviceWorker";
import { initializeAnalyticsRuntime } from "./services/analytics/analyticsClient";
import { initializeNativeLifecycle } from "./services/platform/lifecycle";
import { initializeNativeCaptureRecovery } from "./services/platform/nativeCapture";

initializeAnalyticsRuntime();
void initializeNativeLifecycle().catch(() => {
  // Browser events remain available when a platform listener cannot initialize.
});
void initializeNativeCaptureRecovery().catch(() => undefined);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

registerServiceWorker();
